<template>
  <div class="inner-box">
    <div class="content-name">
      <h2 class="dp-ib">방문신청 정보</h2>
      <div class="btn-wrap btn-type1 clearfix">
        <!--      <button class="btn-size btn-gray fl_left" @click="buttonEventPrint">
          <span class="btn-icon"><i class="fas fa-print"></i></span>
          출력
        </button>-->
        <button class="btn-size btn-blue fl_left" @click="buttonEventViewSubmit" v-if="isViewAppr">
          <span class="btn-icon"><i class="fas fa-vote-yea"></i></span>
          결재보기
        </button>
        <button class="btn-size btn-blue fl_left" @click="buttonEventSubmit" v-if="isSubmitable">
          <span class="btn-icon">
            <i class="fas fa-pen-alt"></i>
          </span>
          결재상신
        </button>
        <!--      <button class="btn-size btn-gray fl_left" @click="buttonEventSave" v-if="isSaveable">
          <span class="btn-icon">
            <i class="fas fa-check"></i>
          </span>
          저장
        </button>-->
        <button class="btn-size btn-orange fl_left" @click="buttonEventCancel" v-if="isCancelable && cancelYN === true">
          <span class="btn-icon">
            <i class="fas fa-times"></i>
          </span>
          방문취소
        </button>
        <button class="btn-size btn-yellow fl_left" @click="buttonEventDone" v-if="isDoneable && cancelYN === false">
          <span class="btn-icon">
            <i class="fas fa-check"></i>
          </span>
          방문완료
        </button>
        <button class="btn-size btn-gray fl_left" @click="goBack()">
          <span class="btn-icon">
            <i class="fas fa-arrow-circle-left"></i>
          </span>
          뒤로가기
        </button>
      </div>
    </div>

    <visit-short :visitNo="visitNo" v-model="data" :status="status" />
  </div>
</template>
  
<script>
import visit from '@/mixin/visit-basic'
import VisitShort from '@/components/visit/VisitShortMg.vue';

export default {
  props: {
    value: {
      type: Object,
      required: false
    }
  },
  components: {
    VisitShort,
  },
  mixins: [visit],
  data() {
    return {
      name: 'VisitMngMg',
      data: {
        visitDetails: []
      },
      cancelYN: '999'
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
}
</script>
  